<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Transactions Report for Today",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        mode: '',
        category: '',
        branch_id:0,
        title: 'Transactions Report for Today'
      },
      title: "Transactions Report",
      items: [
        {
          text: "Transactions Report",
          href: "/",
        },
        {
          text: "Transactions Report",
          active: true,
        },
      ],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      totalRows: 1,
      total_amount_in:0,
      total_amount_out:0,
      total_profit:0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount_in",
          sortable: true,
          label: "DEBIT",
        },
        {
          key: "amount_out",
          sortable: true,
          label: "CREDIT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "RECORDED ON",
        }
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount_in",
          sortable: true,
          label: "DEBIT",
        },
        {
          key: "amount_out",
          sortable: true,
          label: "CREDIT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "RECORDED ON",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        }
      ],
      options: [
        { value: '', label: 'All Categories' },
        { value: '1', label: 'Sales' },
        { value: '2', label: 'Expenses' },
        { value: '3', label: 'Purchases' },
        { value: '4', label: 'Sales Returns'},
        { value: '5', label: 'Purchase Returns'},
        { value: '6', label: 'CashOut'},
        { value: '7', label: 'CashIn'},
        { value: '8', label: 'Money Transfer'},
        { value: '9', label: 'Customer Deposits'},
        { value: '10', label: 'Opening Balance'},
        { value: '11', label: 'Purchase Order'},
        { value: '12', label: 'Supplier Deposits'},
        { value: '13', label: 'Imported Debtors'},
        { value: '14', label: 'Customer Refund'},
        { value: '15', label: 'Imported Creditors'},
        { value: '16', label: 'Ledger Transaction'},
        { value: '17', label: 'Vehicle Expenses'},
      ],
      json_fields: {
        DATE: "date",
        CATEGORY: "category",
        DEBIT: "amount_in",
        CREDIT: "amount_out",
        BALANCE: "balance",
        MODE: "mode",
        RECORDED_ON: "recordedon",
        RECORDED_BY: "recordedby",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("accounts", ["GetTransactions", "SaveStatus"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", ["business","branch","Branches","branchid"]),
    ...mapGetters("setting", ["GeneralSettings", "PaymentOptions"]),

    PaymentOptionsWithAll() {
      // Add the "All" option at the start of the array
      return [{ id: "", mode: "All Modes" }, ...(Array.isArray(this.PaymentOptions) ? this.PaymentOptions : [])];
    },

    transactionsWithBalance() {
      let balance = 0;
      const transactions = Array.isArray(this.GetTransactions) ? this.GetTransactions : [];

      return transactions.slice()
        .reverse()
        .map(transaction => {
          balance += transaction.amount_in - transaction.amount_out;
          return {
            ...transaction,
            balance
          };
        })
        .reverse();
    },

    
    /**
     * Total no. of records
     */

    rows() {
      return this.transactionsWithBalance ? this.transactionsWithBalance.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.transactionsWithBalance ? this.transactionsWithBalance.length : 1;
  },
  methods: {
    ...mapActions({
      FetchTransactions: "accounts/fetchTransactions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",
      FetchPaymentOptions: "setting/fetchPaymentOptions",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SetData(){
      this.FetchTransactions(this.data);
      if(this.data.category != ''){
        let cat = '';
        if(this.data.category == 1){
            cat = 'Sales';
        }else if(this.data.category == 2){
            cat = 'Expenses';
        }else if(this.data.category == 3){
            cat = 'Purchases';
        }else if(this.data.category == 4){
            cat = 'Sales returns';
        }else if(this.data.category == 5){
            cat = 'Purchases returns';
        }else if(this.data.category == 6){
            cat = 'Cashout';
        }else if(this.data.category == 7){
            cat = 'Cashin';
        }else if(this.data.category == 8){
            cat = 'Money transfers';
        }else if(this.data.category == 9){
            cat = 'Customer deposits';
        }else if(this.data.category == 10){
            cat = 'Opening Balance';
        }else if(this.data.category == 11){
            cat = 'Purchase Order';
        }else if(this.data.category == 12){
            cat = 'Supplier deposits';
        }else if(this.data.category == 13){
            cat = 'Imported Debtors';
        }else if(this.data.category == 14){
            cat = 'Customer refunds';
        }else if(this.data.category == 15){
            cat = 'Imported creditors';
        }else if(this.data.category == 16){
            cat = 'Ledger transactions';
        }else if(this.data.category == 17){
            cat = 'Vehicle expenses';
        }
        this.data.title = "Transactions Report for "+cat+" From "+
        this.data.datefrom +
        " To " +
        this.data.dateto;
      }else{
        this.data.title = "Transactions Report From "+
        this.data.datefrom +
        " To " +
        this.data.dateto;
      }
    },
  },
  updated() {    
    let total_amount_out = 0;
    let total_amount_in = 0;
    if(this.transactionsWithBalance){
      this.transactionsWithBalance.forEach((item)=>{
        total_amount_in = total_amount_in+parseInt(item.amount_in);
        total_amount_out = total_amount_out+parseInt(item.amount_out);
      });
      this.total_amount_in = total_amount_in;
      this.total_amount_out = total_amount_out;
    }
  },

  // watch: {
  //   GetTransactions(newValue){
  //     if(newValue){
  //       this.FetchTransactions(this.data);
        
  //     }
  //   },
  // },
  
  created() {
    this.FetchTransactions(this.data);
    this.FetchGeneralSettings();
    this.FetchBranches();
    this.FetchPaymentOptions();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="data.title"></h3>
              </div>
              <div class="col-md-3 form-group">
                <label>PAYMENT MODES</label>                    
                <model-list-select
                  :list="PaymentOptionsWithAll ? PaymentOptionsWithAll : []"
                  v-model="data.mode"
                  option-value="id"
                  option-text="mode"
                  placeholder="Select Payment Option"
                  @input="SetData()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>
                
                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="data.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="SetData()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="transactionsWithBalance"
                  :fields="json_fields"
                  :worksheet="'TRANSACTIONS REPORT(CASH FLOW STATEMENT) FOR ' + currentdate"
                  type="xls"
                  :name="'Transactions_report(Cash flow statement) ' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>CATEGORIES</label>
                
                <model-list-select
                  :list="options ? options : []"
                  v-model="data.category"
                  option-value="value"
                  option-text="label"
                  placeholder="Select Category"
                  @input="SetData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="SetData()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="transactionsWithBalance?transactionsWithBalance:[]"
                  :fields="branchid==0?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amount_in)="data">
                  {{ data.item.amount_in?data.item.amount_in.toLocaleString():0 }}
                </template>
                <template #cell(amount_out)="data">
                  {{ data.item.amount_out?data.item.amount_out.toLocaleString():0 }}
                </template>
                <template #cell(balance)="data">
                  {{ data.item.balance?data.item.balance.toLocaleString():0 }}
                </template>
              </b-table>
                <div class="row">
                  <div class="col-md-4">
                    <h5>Total Debit Amount: <span class="text-danger">{{(total_amount_in).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Credit Amount: <span class="text-danger">{{(total_amount_out).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Net Income: <span class="text-danger">{{(total_amount_in - total_amount_out).toLocaleString()}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!transactionsWithBalance"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
